export default function ArrowDownIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.24661 11.5567L12.5331 6.13636C12.8005 5.86054 12.6384 5.33325 12.2861 5.33325H3.71321C3.36093 5.33325 3.1988 5.86054 3.46627 6.13636L7.75274 11.5567C7.89483 11.7032 8.10452 11.7032 8.24661 11.5567Z"
        fill="currentColor"
      />
    </svg>
  )
}
